import { render, staticRenderFns } from "./FeedbackTicketModal.vue?vue&type=template&id=3d64606f&scoped=true"
import script from "./FeedbackTicketModal.vue?vue&type=script&lang=js"
export * from "./FeedbackTicketModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d64606f",
  null
  
)

export default component.exports